import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

const getRemaining = () => {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  let diff = Math.max(0, end - now);
  const d = Math.floor(diff / 86400000);
  diff -= d * 86400000;
  const h = Math.floor(diff / 3600000);
  diff -= h * 3600000;
  const m = Math.floor(diff / 60000);
  diff -= m * 60000;
  const s = Math.floor(diff / 1000);
  return { d, h, m, s };
};

export const OfferCountdown = ({ dark = false }) => {
  const [t, setT] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="offer-countdown"
      className={`inline-flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border-2 px-4 py-2.5 ${
        dark ? "border-white/40 bg-hero-black/80 text-white" : "border-hero-black bg-hero-gold text-hero-black"
      }`}
      role="timer"
      aria-label="Time remaining for the 50 percent first month offer"
    >
      <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.15em]">
        <Timer className="h-4 w-4" aria-hidden="true" /> 50% off month 1 ends in
      </span>
      <span className="font-display text-base font-bold tabular-nums tracking-wide">
        {t.d}d : {pad(t.h)}h : {pad(t.m)}m : {pad(t.s)}s
      </span>
    </div>
  );
};
